import { render, staticRenderFns } from "./DeletedWorkersTable.vue?vue&type=template&id=093d8151&"
import script from "./DeletedWorkersTable.vue?vue&type=script&lang=ts&"
export * from "./DeletedWorkersTable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports